import { useContext } from 'react'

import { ToastContext } from '~/src/components/generic/Toast/context'

/**
 * Hook to use the Toast context
 * @returns Toast context
 */
export const useToast = () => useContext(ToastContext)
